import { AxiosInstance } from "axios";
import {
  createEhsRoleMutation,
  ehsRoleQuery,
  ehsRolesListQuery,
  getEhsCapabilitiesListQuery,
  getEhsPermissionsListQuery,
  updateEhsRoleMutation,
} from "../components/supportFunctions/graphql/RolesQueries";
import {
  CreateEhsRoleInput,
  PermissionsFilterInput,
  RolesFilterInput,
  UpdateEhsRoleInput,
} from "../components/routeComponents/EhsConfiguration/EhsRoleTypes";
import BaseService from "./BaseService";

class EhsService extends BaseService {
  public api: AxiosInstance;

  constructor() {
    super(process.env.REACT_APP_GRAPHQL_V5_URL);
  }

  async getEhsRoles(paginationInput: any, filters: RolesFilterInput) {
    try {
      const result = await this.api.post(
        "?query=getEhsRoles",
        ehsRolesListQuery(paginationInput, filters)
      );

      return result.data.data.ehsRoles;
    } catch (error) {
      throw error;
    }
  }

  async getEhsPermissions(
    paginationInput: any,
    filters: PermissionsFilterInput
  ) {
    try {
      const result = await this.api.post(
        "?query=ehsPermissions",
        getEhsPermissionsListQuery(paginationInput, filters)
      );

      return result.data.data.ehsPermissions;
    } catch (error) {
      throw error;
    }
  }

  async getEhsRole(customerId: string, id: string) {
    try {
      const result = await this.api.post(
        "?query=getEhsRole",
        ehsRoleQuery(customerId, id)
      );

      return result.data.data.ehsRole;
    } catch (error) {
      throw error;
    }
  }

  async createEhsRole(input: CreateEhsRoleInput) {
    try {
      const result = await this.api.post(
        "?query=createEhsRole",
        createEhsRoleMutation(input)
      );

      return result.data.data.createEhsRole;
    } catch (error) {
      throw error;
    }
  }

  async updateEhsRole(input: UpdateEhsRoleInput) {
    try {
      const result = await this.api.post(
        "?query=updateEhsRole",
        updateEhsRoleMutation(input)
      );

      return result.data.data.updateEhsRole;
    } catch (error) {
      throw error;
    }
  }

  async getEhsCapabilities(input: { customerId: string }) {
    try {
      const result = await this.api.post(
        "?query=ehsCapabilities",
        getEhsCapabilitiesListQuery(input)
      );

      return result.data.data.ehsCapabilities;
    } catch (error) {
      throw error;
    }
  }
}

export default new EhsService();
